import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { JsonLd } from "@/components/JsonLd";
import { Faq } from "@/components/Faq";
import { AdSlot } from "@/components/AdSlot";
import { Card } from "@/components/ui/card";
import GetraenkeRechner from "@/components/getraenke/GetraenkeRechner";
import { GETRAENKE_SEITEN, GETRAENKE_HUB } from "@/lib/getraenkeSeiten";

export default function GetraenkeHubPage() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = origin ? `${origin}/${GETRAENKE_HUB.slug}` : undefined;

  const jsonLd = [
    {
      "@context": "https://schema.org", "@type": "WebApplication",
      name: "Getränkerechner", url: canonical, applicationCategory: "UtilityApplication",
      operatingSystem: "Web", offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" }, inLanguage: "de-DE",
    },
    {
      "@context": "https://schema.org", "@type": "FAQPage",
      mainEntity: GETRAENKE_HUB.faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <Seo title={GETRAENKE_HUB.title} description={GETRAENKE_HUB.description} canonical={canonical} />
      <JsonLd data={jsonLd} />
      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">{GETRAENKE_HUB.h1}</h1>
      <p className="mt-3 text-muted-foreground leading-relaxed">
        Plane die Getränke für deine Feier: Gästezahl, Dauer und Alkoholanteil eingeben, und du bekommst eine Einkaufsliste mit Bier, Wein, Sekt, Wasser und Softdrinks samt Flaschen und Kästen.
      </p>
      <div className="mt-6"><GetraenkeRechner /></div>
      <div className="mt-8"><AdSlot variant="banner" /></div>
      <section className="mt-8">
        <h2 className="text-xl font-semibold mb-3">Für deinen Anlass</h2>
        <div className="grid sm:grid-cols-2 gap-3">
          {GETRAENKE_SEITEN.map((s) => (
            <Link key={s.slug} to={`/${s.slug}`} className="block">
              <Card className="p-4 h-full hover:shadow-md transition-shadow">
                <div className="font-semibold text-sm">{s.h1}</div>
                <div className="text-sm text-muted-foreground mt-1">{s.description}</div>
              </Card>
            </Link>
          ))}
        </div>
      </section>
      <section className="mt-10">
        <h2 className="text-xl font-semibold mb-4">Häufige Fragen</h2>
        <Faq items={GETRAENKE_HUB.faq} testId="getraenke-hub-faq" />
      </section>
      <div className="mt-10"><AdSlot variant="banner" /></div>
    </div>
  );
}
